export function getShopifyTags(
  existingTags: string[],
  useProductCategoryAsTags: boolean,
  existingProductCategoryLabel: string,
  newProductCategoryLabel: string
) {
  if (useProductCategoryAsTags) {
    // Set allows for easy deletion of entities when Product Categories changes and existingProductCategoryLabel is set.
    const shopifyTagsSet = new Set(existingTags)
    const oldProductCategoryTags = existingProductCategoryLabel ? existingProductCategoryLabel.split(' > ') : []
    const newProductCategoryTags = newProductCategoryLabel ? newProductCategoryLabel.split(' > ') : []

    // Remove old product category tags from set.
    oldProductCategoryTags.forEach(tag => {
      shopifyTagsSet.delete(tag)
    })

    // Use set to ensure no duplicates between newProductCategoryTags and the Existing shopifyTagsSet
    // on load or on product category change. Always include Product category tags before other tags.
    return Array.from(new Set([...newProductCategoryTags, ...Array.from(shopifyTagsSet)]))
  }

  return existingTags || []
}

export function getShopifyRequiredTags(useProductCategoryAsTags: boolean, productCategoryLabel: string) {
  if (useProductCategoryAsTags === true) {
    return productCategoryLabel ? productCategoryLabel.split(' > ') : []
  }

  return []
}
